import { skipToken, useQuery } from '@tanstack/react-query'

import { contentApi } from '../../api/content-api'
import { contentKeys } from '../../api/query-keys'

export function useContentReaderTree(entityId: string | null) {
  return useQuery({
    queryKey: contentKeys.readerTree(entityId ?? ''),
    queryFn: entityId === null ? skipToken : () => contentApi.getReaderTree(entityId),
  })
}

export function useContentReaderDocument(entityId: string | null, slug: string | null) {
  return useQuery({
    queryKey: contentKeys.readerDocument(entityId ?? '', slug ?? ''),
    queryFn: entityId === null || slug === null ? skipToken : () => contentApi.getReaderDocument(entityId, slug),
  })
}

export function useContentReaderSearch(entityId: string | null, query: string) {
  return useQuery({
    queryKey: contentKeys.readerSearch(entityId ?? '', query),
    queryFn: entityId === null || query.trim().length < 3
      ? skipToken
      : () => contentApi.searchReaderDocuments(entityId, query),
  })
}
